import { ReactElement, ReactNode } from "react";
import { Popover } from "radix-ui";
import { HiChevronDown } from "react-icons/hi";
import { twMerge } from "tailwind-merge";

import { I18nKeyType } from "@/i18n";
import { useTranslate } from "@/i18n/useTranslate.ts";

type SvPopoverMenuProps = {
  IconLeft?: ReactElement;
  children: ReactNode | ReactNode[];
  className?: string;
} & (
  | {
      i18nKey: I18nKeyType;
      i18nOptions?: object;
      trigger?: never;
    }
  | {
      trigger: ReactNode | ReactNode[];
      i18nKey?: never;
      i18nOptions?: never;
    }
);

export const SvPopoverMenu = ({
  i18nKey,
  i18nOptions,
  trigger,
  IconLeft,
  children,
  className,
}: SvPopoverMenuProps) => {
  const i18Text = useTranslate(i18nKey, i18nOptions);

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <div
          className={twMerge(
            "group flex cursor-pointer flex-row items-center justify-center gap-2 select-none",
            className,
          )}>
          {IconLeft}
          {i18Text ?? trigger}
          <HiChevronDown className="text-primary transition-transform duration-300 group-data-[state=open]:-rotate-180" />
        </div>
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Content className="data-[state=open]:data-[side=bottom]:animate-slideUpAndFadeIn data-[state=open]:data-[side=left]:animate-slideRightAndFadeIn data-[state=open]:data-[side=right]:animate-slideLeftAndFade data-[state=open]:data-[side=top]:animate-slideDownAndFade data-[state=closed]:data-[side=bottom]:animate-slideDownAndFadeOut data-[state=closed]:data-[side=left]:animate-slideLeftAndFadeOut data-[state=closed]:data-[side=right]:animate-slideRightAndFadeOut data-[state=closed]:data-[side=top]:animate-slideUpAndFadeOut min-w-36 rounded bg-white p-4 shadow-[0_4px_38px_0_rgba(0,0,0,.10)] will-change-[transform,opacity] focus:outline-0">
          {children}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};
